import bus from "./bus";
import config from "./config";
import echarts from "echarts";
import {
  formatDate
} from "./parseTime";
import {
  drawerLine
} from "./chartsLine";
import {
  drawerBar
} from "./chartsBar";
import {
  drawerPie
} from "./chartsPie";

const custom = {
  bus,
  formatDate,
  config,
  echarts,
  drawerLine,
  drawerBar,
  drawerPie,
};

export default custom;



// WEBPACK FOOTER //
// ./src/util/custom.js